import { RoleConfig } from '../types/roles';

export const roleConfigurations: Record<string, RoleConfig> = {
  super_admin: {
    name: 'Super Administrator',
    description: 'Complete system control and configuration',
    permissions: {
      project: 'full',
      design: 'full',
      manufacturing: 'full',
      procurement: 'full',
      production: 'full',
      inventory: 'full',
      sales: 'full',
      crm: 'full',
      hr: 'full',
      dashboard: 'full'
    },
    dashboardAccess: ['all']
  },
  admin: {
    name: 'Administrator',
    description: 'Full system access and configuration management',
    permissions: {
      project: 'full',
      design: 'full',
      manufacturing: 'full',
      procurement: 'full',
      production: 'full',
      inventory: 'full',
      sales: 'full',
      crm: 'full',
      hr: 'full',
      dashboard: 'full'
    },
    dashboardAccess: ['all']
  },
  owner: {
    name: 'Owner',
    description: 'Business oversight and performance monitoring',
    permissions: {
      project: 'full',
      design: 'full',
      manufacturing: 'full',
      procurement: 'full',
      production: 'full',
      inventory: 'full',
      sales: 'full',
      crm: 'full',
      hr: 'full',
      dashboard: 'full'
    },
    dashboardAccess: ['all']
  },
  procurement_officer: {
    name: 'Procurement Officer',
    description: 'Manages RFQs, quotations, POs and supplier engagements',
    permissions: {
      project: 'read',
      design: 'read',
      manufacturing: 'none',
      procurement: 'full',
      production: 'none',
      inventory: 'read',
      sales: 'none',
      crm: 'none',
      hr: 'none',
      dashboard: 'read'
    },
    dashboardAccess: ['procurement']
  },
  project_manager: {
    name: 'Project Manager',
    description: 'Project planning and execution management',
    permissions: {
      project: 'full',
      design: 'read',
      manufacturing: 'read',
      procurement: 'read',
      production: 'read',
      inventory: 'read',
      sales: 'none',
      crm: 'none',
      hr: 'none',
      dashboard: 'read'
    },
    dashboardAccess: ['project']
  },
  design_manager: {
    name: 'Design Manager',
    description: 'Design task management and approval workflows',
    permissions: {
      project: 'read',
      design: 'full',
      manufacturing: 'none',
      procurement: 'none',
      production: 'none',
      inventory: 'none',
      sales: 'none',
      crm: 'none',
      hr: 'none',
      dashboard: 'read'
    },
    dashboardAccess: ['design']
  },
  production_manager: {
    name: 'Production Manager',
    description: 'Production planning and oversight',
    permissions: {
      project: 'read',
      design: 'read',
      manufacturing: 'full',
      procurement: 'read',
      production: 'full',
      inventory: 'read',
      sales: 'none',
      crm: 'none',
      hr: 'none',
      dashboard: 'read'
    },
    dashboardAccess: ['production']
  },
  inventory_manager: {
    name: 'Inventory Manager',
    description: 'Inventory and stock management',
    permissions: {
      project: 'none',
      design: 'none',
      manufacturing: 'read',
      procurement: 'read',
      production: 'none',
      inventory: 'full',
      sales: 'none',
      crm: 'none',
      hr: 'none',
      dashboard: 'read'
    },
    dashboardAccess: ['inventory']
  },
  sales_team: {
    name: 'Sales Team',
    description: 'Sales and customer management',
    permissions: {
      project: 'read',
      design: 'none',
      manufacturing: 'none',
      procurement: 'none',
      production: 'none',
      inventory: 'read',
      sales: 'full',
      crm: 'full',
      hr: 'none',
      dashboard: 'read'
    },
    dashboardAccess: ['sales']
  },
  hr_manager: {
    name: 'HR Manager',
    description: 'Human resource management',
    permissions: {
      project: 'read',
      design: 'none',
      manufacturing: 'none',
      procurement: 'none',
      production: 'none',
      inventory: 'none',
      sales: 'none',
      crm: 'none',
      hr: 'full',
      dashboard: 'read'
    },
    dashboardAccess: ['hr']
  },
  worker: {
    name: 'Worker',
    description: 'Basic access for task execution and updates',
    permissions: {
      project: 'read',
      design: 'none',
      manufacturing: 'read',
      procurement: 'none',
      production: 'read',
      inventory: 'none',
      sales: 'none',
      crm: 'none',
      hr: 'none',
      dashboard: 'read'
    },
    dashboardAccess: ['tasks', 'schedule']
  }
};